import React from "react";
import { useSelector } from "react-redux";
import dummyUserProfile from '../images/dummyUser.svg'
const UserProfile = () => {
  const userData = useSelector(state => state.getUserProfile?.userInfo);

  return (
    <React.Fragment>
      <div className="aside-heading">
        <h3>User Profile</h3>
      </div>
      <div className="container">
        <div className="profile">
          <img
            src={ userData.profileImage !== null ? userData.profileImage : dummyUserProfile }
            alt=""
            className="profile-pic"
          />
          <p>
            <strong>{userData?.firstName} {userData?.lastName}</strong>
          </p>
        </div>
        <div className="details">
          <h2>User Details</h2>
          <p>
            <strong>Email:</strong> {userData.emailId}
          </p>
          <p>
            <strong>Phone:</strong> ({userData.countryCode}) {userData?.mobileNumber}
          </p>
          <p>
            <strong>Gender:</strong> {userData.gender}
          </p>
          <p>
            <strong>Role:</strong> {userData.role}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};
export default UserProfile;
